import React from 'react';
import Container from './ui/Container';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

export default function DueDiligence({ content }) {
  return (
    <section className="py-24 bg-slate-900 text-white">
      <Container>
        <div className="max-w-3xl mx-auto text-center">
          <div className="inline-flex items-center justify-center p-3 bg-white/10 rounded-full mb-8">
            <SafeIcon icon={FiIcons.FiSearch} className="w-6 h-6 text-white" />
          </div>
          
          <h2 className="text-3xl font-bold mb-8">
            {content.heading}
          </h2>

          <div className="space-y-6 text-lg text-slate-300 leading-relaxed">
            {content.text.map((paragraph, idx) => (
              <p key={idx}>{paragraph}</p>
            ))}
          </div>
        </div>
      </Container>
    </section>
  );
}